<template>
	<div>
		<vs-upload class="mt-2" fileName="files[]" automatic :action="imageUploadUrl" :headers="uploadHeaders" @on-success="successUpload($event)"/>
		<div id="data-list-list-view" class="data-list-container">

			<vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" search :data="uploads">

				<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

					<div class="flex flex-wrap-reverse items-center">
						<!-- ADD NEW -->
						<div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-danger" @click="deleteItems">
							<span class="ml-2 text-base text-danger">Delete</span>
						</div>
					</div>

					<!-- ITEMS PER PAGE -->
					<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
						<div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
							<span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ uploads.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : uploads.length }} of {{ uploads.length }}</span>
							<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
						</div>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<vs-dropdown-menu>

							<vs-dropdown-item @click="itemsPerPage=4">
								<span>4</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="itemsPerPage=10">
								<span>10</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="itemsPerPage=15">
								<span>15</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="itemsPerPage=20">
								<span>20</span>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</div>

				<template slot="thead">
					<vs-th sort-key="product">Product</vs-th>
					<vs-th sort-key="url">Url</vs-th>
					<vs-th sort-key="type">Type</vs-th>
				</template>

				<template slot-scope="{data}">
					<tbody>
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td>
							<p class="product-name font-medium">{{ tr.product_id }}</p>
						</vs-td>

						<vs-td>
							<p class="product-category">{{ tr.url }}</p>
						</vs-td>

						<vs-td>
							<vs-chip>{{ tr.type }}</vs-chip>
						</vs-td>
					</vs-tr>
					</tbody>
				</template>
			</vs-table>
		</div>
	</div>
</template>
<script>

	import api from '../api';
	import {baseUrl} from "../api";
	import {mapState} from "vuex";
	export default {
		name: 'FileUpload',
		components: {},
		props: {},
		data () {
			return {
				imageUploadUrl: baseUrl + 'admin/file-upload',
				uploads: [],
				itemsPerPage: 5,
				selected: [],
				currentPage: 1,

			}
		},
		computed: {
			...mapState({
				authToken: state=>state.auth.token
			}),
			uploadHeaders(){
				return {
					Authorization: 'Bearer ' + this.authToken
				}
			}
		},
		mounted () {
			this.getUploads();
		},
		methods: {
			getUploads(){
				api.get("admin/file-uploads").then(response=>{
					console.log(response.data.data);
					this.uploads = response.data.data;
				}).catch((error)=>{
					console.log(error);
				})
			},
			successUpload(e){
				let response = JSON.parse(e.target.responseText);
				console.log(response);
				this.getUploads();
			},
			deleteItems(){
				api.post("admin/file-uploads/delete", {ids: this.selected.map(upload=>upload.id)}).then(()=>{
					this.getUploads();
				});
			}
		}
	}

</script>
